module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "primary"
  }, [_vm._v("Awesome IPL dashboard")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("\n    The Indian Premier League is a professional Twenty20 cricket league in\n    India contested during April and May of every year by teams representing\n    Indian cities.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("\n    Awesome IPL dashboard is a collection of visualizations and trivia\n    of IPL data from 2008 to 2016 season.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-4"
  }, [_c('router-link', {
    staticClass: "sidebar-link btn-link",
    attrs: {
      "to": {
        path: '/finals'
      }
    }
  }, [_vm._v("\n        Season Finals\n      ")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-4"
  }, [_c('router-link', {
    staticClass: "sidebar-link btn-link",
    attrs: {
      "to": {
        path: '/batsmen-total-runs'
      }
    }
  }, [_vm._v("\n        Top Batsmen\n      ")]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-4"
  }, [_c('router-link', {
    staticClass: "sidebar-link btn-link",
    attrs: {
      "to": {
        path: '/bowler-total-wickets'
      }
    }
  }, [_vm._v("\n        Top bowlers\n      ")]), _vm._v(" "), _vm._m(2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-4 col-offset-2"
  }, [_c('router-link', {
    staticClass: "sidebar-link btn-link",
    attrs: {
      "to": {
        path: '/awards-motm'
      }
    }
  }, [_vm._v("\n        Player Awards\n      ")]), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-4"
  }, [_c('router-link', {
    staticClass: "sidebar-link btn-link",
    attrs: {
      "to": {
        path: '/team-wins'
      }
    }
  }, [_vm._v("\n        Top Teams\n      ")]), _vm._v(" "), _vm._m(4)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Which team has won the IPL "), _c('b', [_vm._v("most times")]), _vm._v("? Which team is most likely to reach\n        an IPL final "), _c('b', [_vm._v("every year")]), _vm._v("?\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Visualizations of top IPL Batsmen based on "), _c('b', [_vm._v("Runs scored")]), _vm._v(", "), _c('b', [_vm._v("Individual scores")]), _vm._v("\n        & "), _c('b', [_vm._v("4's and 6's scored")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Visualizations of top IPL Bowlers based on "), _c('b', [_vm._v("Wickets taken")]), _vm._v(", "), _c('b', [_vm._v("Over's bowled")]), _vm._v("\n        & "), _c('b', [_vm._v("Bowling economy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Who has won most "), _c('b', [_vm._v("Man of the Match")]), _vm._v(" awards,\n        "), _c('b', [_vm._v("Orange Caps")]), _vm._v(" Or "), _c('b', [_vm._v("Purple Caps")]), _vm._v(" across the seasons?\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Visualizations of top IPL teams based on "), _c('b', [_vm._v("Total wins")]), _vm._v(", "), _c('b', [_vm._v("Matches vs Wins")]), _vm._v("\n        & "), _c('b', [_vm._v("4's and 6's scored")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-986d0f8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 402
// module chunks = 1